export const setTitle = (detail: string) => {
  document.title = `${detail} - Robofly`
}

export const setHomeTitle = () => {
  document.title = 'Robofly'
}
